module.exports = __webpack_public_path__ + "static/media/llanta-presion-green.00c262be.svg";